import {useEffect, useState} from 'react'
import {MenuComponent} from '../../../../../../../_metronic/assets/ts/components'
import {initialQueryState, KTSVG} from '../../../../../../../_metronic/helpers'
import {useQueryRequest} from '../../core/QueryRequestProvider'
import {useQueryResponse} from '../../core/QueryResponseProvider'
import DatePicker from 'react-datepicker'
import {getPlan, getUserType} from '../../core/_requests'
    
const EmployeeListFilter = () => {
  const {updateState} = useQueryRequest()
  const {isLoading} = useQueryResponse()
  const [dateRange, setDateRange] = useState([null, null])
  const [plan, setplan] = useState<any>([])
  const [userType, setUserType] = useState<any>([])
  const [planId, setplanId] = useState<string | undefined>()
  const [userTypeId, setUserTypeId] = useState<string | undefined>()
  const [statusId, setstatusId] = useState<string | undefined>()
  const [startDate, endDate] = dateRange
  useEffect(() => {
    MenuComponent.reinitialization()
  }, [])

  const resetData = () => {
    updateState({filter: undefined, ...initialQueryState});
    setDateRange([null, null]);
    setplanId('');
    setUserTypeId('');
    setstatusId('');
  }

  const filterData = () => {
    let date = (document.getElementById('Daterange') as HTMLInputElement).value;
    
    
    updateState({
      filter: { planId , userTypeId , statusId , date},
      ...initialQueryState,
    })
  }

  useEffect(() => {
    getPlan().then((res: any) => {
      setplan(res.data.Data)
    })
    getUserType().then((res: any) => {
      setUserType(res.data.data)
    })
    return ()=>{
      setplan([]);
      setUserType([]);
    }
  }, [])
  return (
    <>
      {/* begin::Filter Button */}
      <button
        disabled={isLoading}
        type='button'
        className='btn btn-light-primary me-3'
        data-kt-menu-trigger='click'
        data-kt-menu-placement='bottom-end'
      >
        <KTSVG path='/media/icons/duotune/general/gen031.svg' className='svg-icon-2' />
        Filter
      </button>
      {/* end::Filter Button */}
      {/* begin::SubMenu */}
      <div className='menu menu-sub menu-sub-dropdown w-300px w-md-325px' data-kt-menu='true' style={{ maxHeight: 'calc(400px - 80px)', overflowY: 'auto' }}>
        {/* begin::Header */}
        <div className='px-7 py-5'>
          <div className='fs-5 text-dark fw-bolder'>Filter Options</div>
        </div>
        {/* end::Header */}

        {/* begin::Separator */}
        <div className='separator border-gray-200'></div>
        {/* end::Separator */}

        {/* begin::Content */}
        <div className='px-7 py-5' data-kt-user-table-filter='form'>
          {/* begin::Input group */}
          {/* <div className='mb-10'>
            <label className='form-label fs-6 fw-bold'>Plan :</label>
            <select
              className='form-select form-select-solid fw-bolder'
              data-kt-select2='true'
              data-placeholder='Select option'
              data-allow-clear='true'
              data-kt-user-table-filter='role'
              data-hide-search='true'
              onChange={(e) => setplanId(e.target.value)}
              value={planId}
            >
              <option value=''>All</option>
              {plan?.map((item: any, i: any) => {
                return (
                  <option key={i} value={item.id}>
                    {item.name}
                  </option>
                )
              })}
            </select>
          </div> */}

          <div className='mb-10'>
            <label className='form-label fs-6 fw-bold'>User Type :</label>
            <select
              className='form-select form-select-solid fw-bolder'
              data-kt-select2='true'
              data-placeholder='Select option'
              data-allow-clear='true'
              data-kt-user-table-filter='role'
              data-hide-search='true'
              onChange={(e) => setUserTypeId(e.target.value)}
              value={userTypeId}
            >
              <></>
              <option value=''>All</option>
              {userType?.map((item: any, i: any) => {
                return (
                  <option key={i} value={item.id}>
                    {item.name}
                  </option>
                )
              })}
            </select>
          </div>

          <div className='mb-10'>
            <label className='form-label fs-6 fw-bold'>User status:</label>
            <select
              className='form-select form-select-solid fw-bolder'
              data-kt-select2='true'
              data-placeholder='Select option'
              data-allow-clear='true'
              data-kt-user-table-filter='role'
              data-hide-search='true'
              onChange={(e) => setstatusId(e.target.value)}
              value={statusId}
            >
              <option value=''>All</option>
              <option value='0'>Inactive</option>
              <option value='1'>Registered</option>
              <option value='2'>Active</option>
              <option value='3'>Expired</option>
            </select>
          </div>
           {/* begin::datefilter */}
           <div className='mb-10'>
              <label className=' col-form-label fw-bold fs-6'>Date Range :</label>
              <div onClick={(e) => e.stopPropagation()}>
              <DatePicker
              className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                id='Daterange'
                selectsRange={true}
                startDate={startDate}
                endDate={endDate}
                onChange={(event: any) => {
                  setDateRange(event)
                }}
                isClearable={true}
                dateFormat='dd/MM/yyyy'
              />
              </div>
            </div>
             {/* begin::datefilter */}
          {/* end::Input group */}

          {/* begin::Actions */}
          <div className='d-flex justify-content-end'>
            <button
              type='button'
              disabled={isLoading}
              onClick={resetData}
              className='btn btn-light btn-active-light-primary fw-bold me-2 px-6'
              data-kt-menu-dismiss='true'
              data-kt-user-table-filter='reset'
            >
              Reset
            </button>
            <button
              disabled={isLoading}
              type='button'
              onClick={filterData}
              className='btn btn-primary fw-bold px-6'
              data-kt-menu-dismiss='true'
              data-kt-user-table-filter='filter'
            >
              Apply
            </button>
          </div>
          {/* end::Actions */}
        </div>
        {/* end::Content */}
      </div>
      {/* end::SubMenu */}
    </>
  )
}

export {EmployeeListFilter}
